import React from "react";
import GenericDrawer from "./GenericDrawer";
import OddsMenuMobile from "../MenuV2/OddsMenuMobile";
import { useSelector } from "react-redux";
import { MenuSelectors } from "../../redux/selectors";
import { DrawerType, VerticalTransition } from "../../constants";
import MobileDrawerHeader from "../MenuV2/MobileDrawerHeader";
import { useNoScroll } from "../../hooks";

const OddsDrawer = function () {
  const oddsMenuVisible = useSelector(MenuSelectors.oddsMenuVisible);

  useNoScroll("oddsDrawer", oddsMenuVisible);

  return (
    <GenericDrawer
      isVisible={oddsMenuVisible}
      menu={DrawerType.OddsMenu}
      header={<MobileDrawerHeader menu={DrawerType.OddsMenu} />}
      verticalTransition={VerticalTransition.Left}
    >
      <OddsMenuMobile />
    </GenericDrawer>
  );
};

export default React.memo(OddsDrawer);
